import React, { useEffect, useState } from "react";
import { useRecoilValue, useRecoilState } from "recoil";
import { userState } from "states/recoil";
import { db } from "api/firebase/firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { Flex, Heading, Card, HStack, Box, Select } from "@chakra-ui/react";
import MapCHart from "views/Charts/MapChart";
import { tahunAnggaranAtom, sheetURLSelector } from "states/recoil";

function DashboardPemda() {
  const user = useRecoilValue(userState);
  const [name, setName] = useState("");
  const [level, setLevel] = useState("");
  const [province, setProvince] = useState("");

  const [tahunAnggaran, setTahunAnggaran] = useRecoilState(tahunAnggaranAtom);

  const sheetURL = useRecoilValue(sheetURLSelector);

  useEffect(() => {
    const fetchUserName = async () => {
      if (user.email) {
        const userRef = doc(db, "users", user.email);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const data = userSnap.data();
          setName(data.name);
          setLevel(data.level);
          setProvince(data.province);
        }
      }
    };

    fetchUserName();
  }, [user.email]);

  return (
    <>
      <Flex direction="column" gap={4} width="100%">
        <Flex justify="space-between" width="100%" alignItems={"center"}>
          <Heading size="md">
            {name ? `Selamat Datang, ${name}` : "Memuat..."}
          </Heading>
          <Box>
            <Select
              fontWeight={600}
              value={tahunAnggaran}
              onChange={(e) => setTahunAnggaran(e.target.value)}
            >
              {/* list requested */}
              <option value="2064924627">TA 2025</option>
              <option value="2134699857">TA 2024</option>
            </Select>
          </Box>
        </Flex>
        <Flex justify="space-between" width="100%" gap={4}>
          <Card width="100%" variant="outline">
            <MapCHart />
          </Card>
        </Flex>
      </Flex>
    </>
  );
}

export default DashboardPemda;
